import { render, staticRenderFns } from "./CreateTable.vue?vue&type=template&id=775cac4d&scoped=true&"
import script from "./CreateTable.vue?vue&type=script&lang=js&"
export * from "./CreateTable.vue?vue&type=script&lang=js&"
import style0 from "./CreateTable.vue?vue&type=style&index=0&id=775cac4d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775cac4d",
  null
  
)

export default component.exports